import { render, staticRenderFns } from "./wildPlantInfo.vue?vue&type=template&id=38aadb70&scoped=true&"
import script from "./wildPlantInfo.vue?vue&type=script&lang=js&"
export * from "./wildPlantInfo.vue?vue&type=script&lang=js&"
import style0 from "./wildPlantInfo.vue?vue&type=style&index=0&id=38aadb70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aadb70",
  null
  
)

export default component.exports